import MasterTab from 'src/components/Layouts/MasterTab.vue';
import Config from 'src/views/Pages/Dashboard/Sigatoka/Config/Config.vue';
import EmptyRouterView from 'src/views/Pages/GeneralViews/EmptyRouterView.vue';
import Report from 'src/views/Pages/Dashboard/Sigatoka/ReportCapture/Report.vue';
import CaptureEditCreate from 'src/views/Pages/Dashboard/Sigatoka/SigatokaCapture/EditCreate.vue';
import ConfigEditCreate from 'src/views/Pages/Dashboard/Sigatoka/Config/EditCreate.vue';
import SigatokaCapture from 'src/views/Pages/Dashboard/Sigatoka/SigatokaCapture/SigatokaCapture.vue';
import SigatokaRanking from 'src/views/Pages/Dashboard/Sigatoka/ReportCapture/SigatokaRanking.vue';
import BiologicalWarningCapture from 'src/views/Pages/Dashboard/Sigatoka/BiologicalWarningCapture/BiologicalWarningCapture.vue';

const SigatokaRouters = {
  path: 'sigatoka',
  name: 'sigatoka.sigatoka',
  component: MasterTab,
  props: { reference: 'sigatokaTabs' },
  children: [
    {
      path: 'config',
      component: EmptyRouterView,
      children: [
        {
          path: '',
          name: 'sigatoka.sigatoka',
          component: Config,
          meta: {
            prefix_permission: 'sigatoka_config',
          },
        },
        {
          path: 'create',
          name: 'sigatoka.sigatoka_config',
          component: ConfigEditCreate,
          meta: {
            prefix_permission: 'sigatoka_config',
          },
        },
        {
          path: 'edit',
          name: 'sigatoka.sigatoka_config',
          component: ConfigEditCreate,
          meta: {
            prefix_permission: 'sigatoka_config',
          },
        },
      ],
    },
    {
      path: 'capture',
      component: EmptyRouterView,
      children: [
        {
          path: '',
          name: 'sigatoka.sigatoka_capture',
          component: SigatokaCapture,
          meta: {
            prefix_permission: 'sigatoka_capture',
          },
        },
        {
          path: 'editcreate',
          name: 'sigatoka.sigatoka_capture',
          component: CaptureEditCreate,
          meta: {
            prefix_permission: 'sigatoka_capture',
          },
        },
      ],
    },
    {
      path: 'capturereport',
      component: EmptyRouterView,
      children: [
        {
          path: '',
          name: 'sigatoka.sigatoka_capture_report',
          component: Report,
          meta: {
            prefix_permission: 'sigatoka_capturereport',
          },
        },
      ],
    },
    {
      path: 'ranking',
      component: EmptyRouterView,
      children: [
        {
          path: '',
          name: 'sigatoka.sigatoka_ranking',
          component: SigatokaRanking,
          meta: {
            prefix_permission: 'sigatoka_ranking',
          },
        },
      ],
    },
    {
      path: 'biologicalwarning',
      component: EmptyRouterView,
      children: [
        {
          path: '',
          name: 'sigatoka.biological_warning',
          component: BiologicalWarningCapture,
          meta: {
            prefix_permission: 'sigatoka_biologicalwarning',
          },
        },
      ],
    },
  ],
};

export default SigatokaRouters;
